import { useEffect } from 'react';

function useTheme(inMobile?: boolean): void {
  useEffect(() => {
    if (inMobile) {
      document.body.classList.add('mobile-mode');
    } else {
      document.body.classList.remove('mobile-mode');
    }
  }, [inMobile]);
}

export default useTheme;
